import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-program-name',
  templateUrl: './program-name.component.html',
  styleUrls: ['./program-name.component.scss']
})
export class ProgramNameComponent implements OnInit {
  @Input() files: File[];
  @Input() prohibitedNames: string[] = [];
  @Input() program: string;
  errorMessage = ""

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  processProgram(): void {
    console.log(this.prohibitedNames);
    for(let test of this.prohibitedNames) {
      console.log(`Comparing ${test} to ${this.program}`)
      if(test == this.program) {
        this.errorMessage = "There is already a file for "+this.program
        return
      }
    }
    this.modal.close(this.program)
  }
}
